import { IGeneralAttributeRateKey } from '../../interfaces/igeneral-attribute-rate-key';
import { GeneralAttribute } from '../general-attribute';
import { ItemRate } from '../item-rate';
import { ResourceCalculation } from '../resource-calculation';

export class GeneralAttributeRateKeyBase {
  GeneralAttributeRateKeyId: number;
  GeneralAttributeId: number;
  ItemRateId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ResourceCalculationId: number | null;

  GeneralAttribute?: GeneralAttribute;
  ItemRate?: ItemRate;
  ResourceCalculation?: ResourceCalculation;

  constructor(item?: IGeneralAttributeRateKey) {
    if (item) {

      this.GeneralAttributeRateKeyId = item.GeneralAttributeRateKeyId;
      this.GeneralAttributeId = item.GeneralAttributeId;
      this.ItemRateId = item.ItemRateId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ResourceCalculationId = item.ResourceCalculationId;

      this.GeneralAttribute = new GeneralAttribute(item.GeneralAttribute);
      this.ItemRate = new ItemRate(item.ItemRate);
      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
    }
  }
}